/* eslint-disable */

import React, { useState } from "react";
import PropTypes from "prop-types";
import TablePaginate from "components/TablePaginate/TablePaginate";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import { Link } from "react-router-dom";
import { stakingService } from "../../services/stakingService";
import ActionNormal from "./ActionNormal";
import NetworkDialog from "./NetworkDialog";
import Select from "components/Select/Select";
import { totalDaysFromSeconds } from "helper/fommaters";
import ActionSoft from "./ActionSoft";
import { chainOptions } from "const";

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function StakingIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [type, setType] = React.useState("");
  const [chainId, setChainId] = React.useState("-1");

  const [openNetwork, setOpenNetwork] = useState(false);
  const [networkTitle, setNetworkTitle] = useState("");
  const [networkCb, setNetworkCb] = useState(() => {});
  const [networkCbApi, setNetworkCbApi] = useState(() => {});

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Thumbnail",
        accessor: "image",
        Cell: Thumbnail,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Status",
        accessor: "status",
      },
        {
            Header: "Address",
            accessor: "address",
            Cell: ({ value }) => (
                <span style={{ wordBreak: "break-all", whiteSpace: "normal" }}>{value}</span>
            ),
        },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Durations",
        Cell: ({ cell }) => (
          <>
            {cell.row.original.type === "soft" && (
              <span>
                {totalDaysFromSeconds(cell.row.original.softConfig.lockTime)}{" "}
                days
              </span>
            )}

            {cell.row.original.type === "normal" && (
              <span>{cell.row.original.weeks} weeks</span>
            )}
          </>
        ),
      },
      {
        Header: "Token/Week",
        Cell: ({ cell }) =>
          cell.row.original.type === "soft"
            ? `Available: ${cell.row.original.rewardAvailable}`
            : cell.row.original.rewardPerWeek || 0,
      },
      {
        Header: "Is V2",
        Cell: ({ cell }) =>
          cell.row.original.type === "soft"
            ? "Soft staking"
            : cell.row.original.stakingV2
            ? "Yes"
            : "No",
      },
      {
        Header: "Boost",
        Cell: ({ cell }) => (
          <>
            {cell.row.original.canBoost && (
              <div>
                <Link
                  to={`/admin/staking-booster-edit/${cell.row.original.address}?chainId=${cell.row.original.chainId}`}
                >
                  <Button color="primary" size="sm">
                    <i className="fas fa-edit" />
                    {cell.row.original.canBoost &&
                    cell.row.original.boosterRatio > 0 ? (
                      <strong> On </strong>
                    ) : (
                      <strong> Off </strong>
                    )}
                  </Button>
                </Link>
              </div>
            )}
            {!cell.row.original.canBoost && "Not supported"}
          </>
        ),
      },
      {
        Header: "APR",
        Cell: ({ cell }) => (
          <>
            <div>
              <Link to={`/admin/staking-apr-edit/${cell.row.original._id}`}>
                <Button color="primary" size="sm">
                  <i className="fas fa-edit" />
                  <strong> Edit </strong>
                </Button>
              </Link>
            </div>
          </>
        ),
      },
      {
        Header: "Action",
        Cell: function action({ cell }) {
          if (cell.row.original.type === "soft") {
            return (
              <ActionSoft
                item={cell.row.original}
                onCallNetwork={showNetwork}
                refresh={handleRefresh}
              />
            );
          }

          return (
            <>
              <ActionNormal
                item={cell.row.original}
                onCallNetwork={showNetwork}
                refresh={handleRefresh}
              ></ActionNormal>
            </>
          );
        },
      },
    ],
    []
  );

  const handleRefresh = () => {
    fetchStakings();
  };

  function showNetwork(title, callback, callApi) {
    setNetworkTitle(title);
    setNetworkCb(() => callback);
    setNetworkCbApi(() => callApi);
    setOpenNetwork(true);
  }

  async function fetchStakings() {
    const payload = {
      search,
      type,
      page,
      size,
      sortBy: "order",
      sortType: "asc",
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;
    try {
      const { data } = await stakingService.list(payload);
      setItems(data.items);
      setCount(+data.paginate.count);
      setPage(+data.paginate.page);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchStakings();
  }, [page, search, type, chainId]);

  return (
    <div>
      {confirm}
      <Link to="/admin/staking-create-select">
        <Button color="info">Create new Staking pool</Button>
      </Link>

      <Link to="/admin/staking-fee">
        <Button color="info">Config fee</Button>
      </Link>

      <Link to="/admin/staking-fee-special">
        <Button color="info">Config fee special</Button>
      </Link>

      <Link to="/admin/staking-fee-test">
        <Button color="info">Fee test</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />

        <Select
          value={type}
          onChange={(selected) => setType(selected)}
          label="Type"
          options={[
            { value: "", label: "All" },
            { value: "soft", label: "Soft" },
            { value: "normal", label: "Normal" },
          ]}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />

      <NetworkDialog
        open={openNetwork}
        onClose={() => setOpenNetwork(false)}
        title={networkTitle}
        action={networkCb}
        callApi={networkCbApi}
        onDone={handleRefresh}
      />
    </div>
  );
}

function Thumbnail({ cell }) {
  return <img src={cell.value} alt="" style={{ height: "50px" }} />;
}

Thumbnail.propTypes = {
  cell: PropTypes.any,
};
